import React, { useState } from "react";
import { useSelector } from "react-redux";
import { IRootState } from "../../../../reducer/CombineReducer";
import { SchedulingModes } from "../CreateSchedule/redux/Types";
import { SaveScheduleView } from "./SaveSchedule.view";

interface ISaveScheduleProps {
  goBack: () => void;
  onSave: () => void;
}

// Responsible for rendering create schedule form
export const SaveSchedule = (props: ISaveScheduleProps): JSX.Element => {
  const { goBack, onSave } = props;
  const [ isDisabled, setIsDisabled ] = useState(false);
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const formFields = scheduling.schedulingDetails;
  const isViewMode = scheduling.mode === SchedulingModes.VIEW;
  const isValidSchedule = Boolean(scheduling.isValidScheduleName);
  const isEmptyScheduleName = Boolean(scheduling.schedulingDetails.scheduleName);

  // Check to enable/disable the save button based on form input data
  const checkToEnableDisableSaveButton = (): boolean => {
    return document.querySelectorAll(".eui-form-element__error").length > 0;
  };

  React.useEffect(() => {
    const isToDisabled = isViewMode || checkToEnableDisableSaveButton() || !isValidSchedule || !isEmptyScheduleName;
    setIsDisabled(isToDisabled);
  }, [formFields, isViewMode, isValidSchedule, isEmptyScheduleName]);

  return (
    <SaveScheduleView
      goBack={goBack}
      isDisabled={isDisabled}
      onSave={onSave}
    />
  );
};
